'use client';

import {Box, styled, Typography} from '@mui/material';
import {StyledSectionContainer} from '@/components/sections/shared/Section.styles';

export const StyledCtaCardSectionContainer = styled(StyledSectionContainer)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  alignItems: 'center',
}));

export const StyledCtaCardSectionHeading = styled(Typography)(({theme}) => ({
  color: theme.palette.text.dark,
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(5),
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(3),
  },
}));

export const StyledCtaCardsContainer = styled(Box)(({theme}) => ({
  width: '100%',
  height: '100%',
  display: 'grid',
  gap: theme.spacing(3),
  gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 'auto',
  backgroundColor: theme.palette.background.lightGrey,
}));

export const StyledCtaItemsContainer = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

